

import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { RuleDefinitionService } from 'tnx-admin-service/ruledefinition/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, ModelSchema } from 'tnx-shared';
@Component({
    selector: 'ruledefinition',
    templateUrl: './ruledefinition.component.html',
    styleUrls: ['./ruledefinition.component.scss'],
    providers: [ComponentContextService],
})
export class RuleDefinitionComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _ruleDefinitionService: RuleDefinitionService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._ruleDefinitionService;
        this.setting.popupSize.width = 1300;
        this.setting.popupSize.height = 650;
        this.setting.modelSchemas = [
            new ModelSchema({
                field: 'title',
                name: 'Tên',
                fullName: 'Tên',
                description: 'Tên',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'code',
                name: 'Mã',
                fullName: 'Mã',
                description: 'Mã',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'clientParams',
                name: 'Danh sách tham số',
                fullName: 'Danh sách tham số',
                description: 'Danh sách tham số',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'clientRules',
                name: 'Danh sách rule',
                fullName: 'Danh sách rule',
                description: 'Danh sách rule',
                dataType: 'string',
            })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'title' }),
            new ColumnSchemaBase({ field: 'code' }),
            new ColumnSchemaBase({ field: 'clientParams', allowFilter: false, sort: false, dataType: 'html' }),
            new ColumnSchemaBase({ field: 'clientRules', allowFilter: false, sort: false, dataType: 'html' })
        ];
        super.ngOnInit();
    }

    async beforeRenderDataSource(datasource: any) {
        for (const item of datasource) {
            try {
                const params = JSON.parse(item.params);
                item.clientParams = '';
                for (const p of params) {
                    item.clientParams += '<div style="padding:5px 0">${' + p.Name + '} = ' + p.Expression + '<div/>';
                }

                const rules = JSON.parse(item.rules);
                item.clientRules = '';
                for (const r of rules) {
                    item.clientRules += '<div style="padding:5px 0"><i class="far fa-check-circle">&nbsp;&nbsp;</i>' + r.Expression + '<div/>';
                }
            }
            catch { }
        }
    }
}
